module.exports = __webpack_public_path__ + "static/media/home-category-3.f164dad5.png";